import { FC } from "react";

import { VnBox } from "@/components/VnBox";
import { VnButton } from "@/components/VnButton/VnButton";
import { I18nKeyType } from "@/i18n";

import { EligibilityScreenLayout } from "./EligibilityScreenLayout";

type EligibilityYesAndNoPropsType = {
  titleI18nKey: I18nKeyType;
  titleI18nOptions?: Record<string, string>;
  descriptionI18nKey?: I18nKeyType;
  descriptionI18nOptions?: Record<string, string>;
  onYesPress: () => void;
  onNoPress: () => void;
  isYesLoading?: boolean;
  isNoLoading?: boolean;
};

export const EligibilityYesAndNo: FC<EligibilityYesAndNoPropsType> = ({
  titleI18nKey,
  titleI18nOptions,
  descriptionI18nKey,
  descriptionI18nOptions,
  onYesPress,
  onNoPress,
  isYesLoading,
  isNoLoading,
}) => {
  return (
    <EligibilityScreenLayout
      titleI18nKey={titleI18nKey}
      titleI18nOptions={titleI18nOptions}
      descriptionI18nKey={descriptionI18nKey}
      descriptionI18nOptions={descriptionI18nOptions}>
      <VnBox className="gap-3">
        <VnButton
          className="border-border justify-start rounded-md"
          variant="outline"
          i18nKey="common:yes"
          onPress={onYesPress}
          isLoading={isYesLoading}
        />
        <VnButton
          className="border-border justify-start rounded-md"
          variant="outline"
          i18nKey="common:no"
          onPress={onNoPress}
          isLoading={isNoLoading}
        />
      </VnBox>
    </EligibilityScreenLayout>
  );
};
